module.exports = __webpack_public_path__ + "static/img/px_1.d18fc88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/px_1.jpg
// module id = 4Ejk
// module chunks = 1